import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import Header from "../components/Header";
import Footer from "../components/Footer";
import GlobalCta from "../components/global/GlobalCta";
import ArticleHead from "../components/article/ArticleHead";
import ArticleBanner from "../components/article/ArticleBanner";
import ArticleBody from "../components/article/ArticleBody";
import AuthorBox from "../components/article/AuthorBox";
import KeepReading from "../components/article/KeepReading";
import { fetchApi } from "../config";

export default function Article() {
    const { slug } = useParams();
    const [post, setPost] = useState(null);
    const [prevPost, setPrevPost] = useState(null);
    const [nextPost, setNextPost] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        let mounted = true;
        async function load() {
            if (!slug) return;
            setLoading(true);
            try {
                const res = await fetchApi(`get_post_by_slug.php?slug=${encodeURIComponent(slug)}`);
                if (!mounted) return;
                if (res) {
                    const data = res.PostData ? (Array.isArray(res.PostData) ? res.PostData[0] : res.PostData) : (Array.isArray(res.Posts) ? res.Posts[0] : null);
                    setPost(data || null);
                    setPrevPost(res.PreviousPost || res.Previous || null);
                    setNextPost(res.NextPost || res.Next || null);
                } else {
                    setPost(null);
                }
            } catch (err) {
                setPost(null);
            } finally {
                if (mounted) setLoading(false);
            }
        }
        load();
        return () => { mounted = false; };
    }, [slug]);

    return (
        <>
            <Header />

            <main>
                <ArticleHead post={post} loading={loading} />

                <ArticleBanner post={post} loading={loading} />

                <ArticleBody post={post} loading={loading} />

                <AuthorBox post={post} />

                <KeepReading prev={prevPost} next={nextPost} loading={loading} />
            </main>

            <GlobalCta />

            <Footer />
        </>
    );
}
